<template>
    <transition name="modal">
        <div class="modal-mask" :style="{zIndex: index + 10}" :id="id" :key="`key_${id}`">
            <div class="modal-container" :class="size || 'small'">
                <div class="modal-header">
                    <h3><slot name="header">{{title}}</slot></h3>
                </div>

                <div class="modal-body">
                    <slot name="body">{{body}}</slot>
                </div>

                <div class="modal-footer">
                    <slot name="footer">
                        <button :class="b.class"
                                type="button"
                                ref="btns"
                                v-for="(b, idx) in buildButtons()"
                                :disabled="b.disabled"
                                :key="idx"
                                @click="b.method(id)">
                            <svg-icon v-if="b.icon"
                                      :class="b.iconClass"
                                      :icon="b.icon"/> {{b.label}}
                        </button>
                    </slot>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    import {mapMutations} from 'vuex'

    const defaultButtons = {
        ok: {
            label: 'Sim',
            icon: 'check',
            class: 'btn btn-sm btn-primary',
            method: () => {}
        },
        no: {
            label: 'Não',
            icon: 'ban',
            class: 'btn btn-sm btn-danger',
            method: () => {}
        },
        close: {
            label: 'Fechar',
            icon: 'times',
            class: 'btn btn-sm btn-dark',
            method: () => {}
        }
    };

    export default {
        name: "Modal",
        props: {
            id: {
                type: String,
                required: true
            },
            size: {
                type: String,
                default: 'small',
                validator: v => /(small|medium|large)/gi.test(v)
            },
            title: {
                type: String,
                default: 'No Title'
            },
            body: {
                type: String,
                default: 'No Body'
            },
            index: {
                type: Number,
                default: 0
            },
            buttons: {
                type: Array,
                default: () => [{
                    type: 'ok',
                    label: 'Ok',
                    icon: 'check',
                    iconClass: '',
                    class: 'btn btn-sm btn-primary',
                    method: () => {}
                }]
            }
        },
        methods: {
            ...mapMutations(['destroyModal']),
            close() {
                this.destroyModal(this.id);
            },
            buildButtons() {
                const b = [];

                this.buttons.forEach(btn => {
                    if(btn.type && defaultButtons[btn.type]) {
                        b.push({...defaultButtons[btn.type], ...btn})
                    } else {
                        b.push(btn)
                    }
                });

                return b;
            }
        },
        mounted() {
            this.buttons.forEach((b, idx) => {
                if (b.focus) {
                    this.$refs.btns[idx].focus();
                    return true;
                }
            })
        }
    }
</script>

<style lang="scss">
    @import "../assets/css/variables";
    .modal-mask {
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        background-color: rgba(0, 0, 0, .5);
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: center;
        transition: opacity .3s ease;
        overflow-y: auto;
    }

    .modal-container {
        margin: 1.75rem auto;
        padding: 20px 30px;
        background-color: #fff;
        border-radius: 2px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
        transition: all .3s ease;
        font-family: Helvetica, Arial, sans-serif;

        &.small {
            width: 300px;
        }
        &.medium {
            width: 700px;
        }
        &.large {
            width: 1000px;
        }
    }

    .modal-header h3 {
        margin-top: 0;
        font-family: 'Montserrat', sans-serif;
        color: $theme_color_one;
        font-weight: 400;
    }

    .modal-body {
        margin: 20px 0;
    }

    .modal-footer {
        display: flex;
        flex-direction: row;
        justify-content: flex-end;

        button:not(:last-child) {
            margin-right: 10px;
        }
    }

    @media (max-width: 576px) {
        .modal-container {
            margin-top: 70px;
            margin-bottom: 10px;
            padding: 15px 5px;
            .modal-header {
                padding-left: 15px;
            }

            &.small {
                width: 300px;
            }
            &.medium {
                width: 97%;
            }
            &.large {
                width: 97%;
            }
        }
    }

    @media (min-width: 768px) {
        .modal-container {
            &.small {
                width: 300px;
            }
            &.medium {
                width: 500px;
            }
            &.large {
                width: 700px;
            }
        }
    }

    @media (min-width: 992px) {
        .modal-container {
            &.small {
                width: 300px;
            }
            &.medium {
                width: 700px;
            }
            &.large {
                width: 1000px;
            }
        }
    }

    .modal-enter, .modal-leave-active {
        opacity: 0;
        transition: all .5s ease-out;
    }

    .modal-enter .modal-container,
    .modal-leave-active .modal-container {
        transform: translateY(-40px) scale(.95);
    }

</style>
